module.exports = __webpack_public_path__ + "img/img-carrusel-empresas-mobile.a9d2edb.webp";